import type { RichTextEvent } from "@library-elements/text";

type RichTextListener = (event: RichTextEvent) => void;

class RichTextEventBus {
  private listeners = new Set<RichTextListener>();

  emit(event: RichTextEvent) {
    this.listeners.forEach((listener) => listener(event));
  }

  /** Emit a toolbar event by attaching the editorId to a partial event. */
  emitWithId(d: Omit<RichTextEvent, "editorId">, editorId: string) {
    this.emit({ ...d, editorId } as RichTextEvent);
  }

  on(listener: RichTextListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  off(listener: RichTextListener) {
    this.listeners.delete(listener);
  }
}

export const RichTextSubject = new RichTextEventBus();
